<template>
    <div class="uppercase text-xl mb-8">
        {{ t.subscribeNewsletter }}
    </div>
    <div class="relative">
        <input-component 
            v-model="email" 
            displayClass="w-full newsletter"
            :errors="errors"
            :placeholder="t.emailAddress"
        />
        <div class="absolute right-0 bottom-0">
            <button class="border border-white text-2xl text-blue bg-white w-10 h-10 text-center leading-4 pointer hover:text-white hover:bg-transparent transition-colors duration-500 cursor-pointer">
                <i class="icon-chevron-right"></i>
            </button>
        </div>
    </div>
    <div class="mt-2 newsletter-checkbox">
        <checkbox-component
            v-model="accepted"
            :options="checkboxOptions"
        >
        </checkbox-component>
    </div>
</template>

<script>
import InputComponent from './Forms/InputComponent'
import CheckboxComponent from './Forms/CheckboxComponent'

export default {
    props: {
        t: Object
    },

    data() {
        return {
            email: '',    
            errors: '',
            accepted: false,
            disableSubmit: false,
            successMsg: false,
            checkboxOptions: [
                {
                    label: this.t.acceptPrivacy,
                    name: 'privacy',
                    value: true
                }
            ]
        }
    },

    components: {
        InputComponent,
        CheckboxComponent
    },

    methods: {
        toggleSubmit() {
            this.disableSubmit = !this.disableSubmit
        },
        submitForm() {
            this.clearErrors()
            this.toggleSubmit()
            axios.post('', this.email)
                .then(response => {
                    this.handleSuccess(response.data)
                })
                .catch(error => {
                    this.handleErrors(error.response)
                }).finally(() => {
                     
                });
        },
        handleSuccess(data) {
            if (data.success == true) {
               // this.successMsg = this.t.successForm
            }
            this.toggleSubmit()
        },
        handleErrors(errors) {
            this.errors = errors.data.error     
            this.toggleSubmit()
        },        
        clearErrors() {
            this.errors = ''
        },
        
    }

};
</script>